import { IParameterizable } from './page-service/parameterizable.model';
import { IQueryParams } from './page-service/query-params.model';

export interface IPagingConfig {
    allowedSizes?: number[];
    pageSize?: number;
    currentPage: number;
    numberOfPages: number;
    totalItems: number;
}

export class Paging implements IParameterizable {
    allowedSizes?: number[];
    pageSize?: number;
    currentPage = 1;
    numberOfPages = 0;
    totalItems = 0;

    constructor(config?: IPagingConfig) {
        if (config) {
            this.allowedSizes = config.allowedSizes ?? [];
            this.pageSize = config.pageSize ?? 0;
            this.currentPage = config.currentPage;
            this.numberOfPages = config.numberOfPages;
            this.totalItems = config.totalItems;
        }
    }

    generateParams(): IQueryParams[] {
        const pageParams: IQueryParams = {
            queryString: 'page',
            params: this.currentPage !== 1 ? [{ value: `${this.currentPage}` }] : [],
        };
        const sizeParams: IQueryParams = {
            queryString: 'pagesize',
            params: this.pageSize ? [{ value: `${this.pageSize}` }] : [],
        };

        return [pageParams, sizeParams];
    }
}
